import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DropdownToggleIconComponent } from "@m19-board/shared/expand-icon/dropdown-toggle-icon.component";
import { ProductGroupUploadResult } from "@m19-board/strategies/strategy-bulk-upload-modal/bulk-import.service";

export interface ProductGroupBulkUploadResultModalData {
  uploadResult: ProductGroupUploadResult;
  updatedEntity?: string;
}

@Component({
  selector: "app-product-group-bulk-upload-result-modal",
  templateUrl: "./product-group-bulk-upload-result-modal.component.html",
  imports: [TranslocoDirective, DropdownToggleIconComponent, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGroupBulkUploadResultModalComponent {
  protected readonly modalData = inject(MODAL_DATA) as ProductGroupBulkUploadResultModalData;
  modalRef = inject(ModalRef);

  successDetailsVisible = false;
  errorDetailsVisible = false;

  toggleSuccessDetails(): void {
    this.successDetailsVisible = !this.successDetailsVisible;
  }

  toggleErrorDetails(): void {
    this.errorDetailsVisible = !this.errorDetailsVisible;
  }
}
